import React from "react";
import { Autocomplete as MuiAutocomplete, Paper, styled } from "@mui/material";

const CustomAutocomplete = styled((props: any) => <MuiAutocomplete {...props} />)(({ theme }) => ({
    "& .MuiFilledInput-root": {
        border: "var(--fq-sketch-border)",
        borderRadius: "255px 15px 225px 15px / 15px 225px 15px 255px",
        overflow: "auto",
        backgroundColor: theme.palette.mode === "light" ? "#fcfcfb" : "#2b2b2b",
        fontFamily: '"Short Stack", "Caveat", cursive',
        transition: theme.transitions.create(["border-color", "background-color", "box-shadow"]),
        "&:hover": {
            backgroundColor: "transparent",
            borderBottomColor: "var(--fq-primary-text-color)",
        },
        "&.Mui-focused": {
            backgroundColor: "transparent",
            borderColor: theme.palette.primary.main,
            boxShadow: "3px 3px 0px " + theme.palette.primary.main,
        },
        "&:before, &:hover:not(.Mui-disabled):before": {
            borderBottomColor: "transparent",
        },
    },
    "& .MuiAutocomplete-input": {
        fontFamily: '"Short Stack", "Caveat", cursive',
        fontSize: 14,
    },
}));

export default function AutoComplete(props: any) {
    return <CustomAutocomplete size={"small"} {...props} PaperComponent={AutoCompletePaper} />;
}

function AutoCompletePaper(props: any) {
    return (
        <Paper
            {...props}
            sx={{
                border: "var(--fq-sketch-border)",
                borderRadius: "15px 225px 15px 255px / 255px 15px 225px 15px",
                mt: 1,
                boxShadow: "4px 4px 0px var(--fq-primary-text-color)",
                zIndex: 10000,
                overflow: "hidden",
                "& .MuiAutocomplete-listbox": {
                    fontFamily: '"Short Stack", "Caveat", cursive',
                    fontSize: 14,
                    padding: "4px 0",
                    "& .MuiAutocomplete-option": {
                        fontFamily: '"Short Stack", "Caveat", cursive',
                        fontSize: 14,
                        padding: "6px 14px",
                        color: "var(--fq-primary-text-color)",
                        '&[aria-selected="true"]': {
                            backgroundColor: "var(--fq-accent-warm)",
                            color: "#2d2d2d",
                        },
                        "&.Mui-focused": {
                            backgroundColor: "rgba(132, 94, 247, 0.2)",
                            color: "var(--fq-primary-text-color)",
                        },
                    },
                },
                "& .MuiAutocomplete-noOptions": {
                    fontFamily: '"Short Stack", "Caveat", cursive',
                    fontSize: 14,
                },
            }}
        />
    );
}
